export default {
  hideLmeDosages(treatment) {
    treatment.dosages.forEach((dosage) => {
      dosage.treatmentDosageLme.firstPrescriptionMonth1 = null
      dosage.treatmentDosageLme.firstPrescriptionMonth2 = null
      dosage.treatmentDosageLme.firstPrescriptionMonth3 = null
      dosage.treatmentDosageLme.firstPrescriptionMonth4 = null
      dosage.treatmentDosageLme.firstPrescriptionMonth5 = null
      dosage.treatmentDosageLme.firstPrescriptionMonth6 = null
    })

    return treatment
  },
}
